<template>
    <div>
        <card-header title='New Session' icon="fa-plus"/>

        <card-body>
            <rmc-session-form :session="session"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!session.title || !session.start_at || !session.end_at"
                    ><i class="fas fa-plus mr-2"></i>New Session</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from "@/http_client";
    import RmcSessionForm from "./SessionForm";

    export default {
        components: {RmcSessionForm, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card', 'props'],
        data() {
            return {
                session: {}
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('rmc/sessions', {conference_id: this.props.confId, ...this.session}, {force: true}).then(response => {
                    this.$reloadCard('rmc-sessions');
                    this.$closeCard(this.card);
                }).catch(err => {
                    if (err.response.status === 400) {
                        window.alert('Conference code must be unique. There is already a session using that code.  Please choose a different once.');
                    } else {
                        window.alert('An error occurred while saving the conference.');
                    }
                    this.$emit('loading', false);
                });
            }
        }
    }
</script>
